import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4805276a"
import script from "./Edit.js?vue&type=script&lang=js&external"
export * from "./Edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports